const PageLoader = () => (
  <div className="loader-container">
    <div className="loader-content">
      <div className="spinner"></div>
      <p className="loader-text">Loading...</p>
    </div>
  </div>
);

export default PageLoader;
